module.exports = __webpack_public_path__ + "static/media/29180031-min.1aaff600.jpg";